<template>
    <div class="">
        <div class="">
            <label class="block text-sm ">Page name<span class="text-red-700">*</span></label>
            <input aria-label="Page name" type="text" required v-model="name" class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                   placeholder="Page name"/>
        </div>
        <div class="my-3">
            <label class="block text-sm ">Styling template<span class="text-red-700">*</span></label>
                <select class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5" v-model="css_template">
                    <option value="tailwind.css">Tailwind</option>
                    <option value="bootstrap4.css">Bootstrap 4</option>
                    <option value="bootstrap3.css">Bootstrap 3</option>
                </select>
            <small>ONLY applies if you are using Page builder option</small>
        </div>
        <div class="my-3">
            <label class="block text-sm leading-5 ">Description</label>
            <textarea v-model="description" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                      placeholder="Describe..."></textarea>
        </div>
        <div class="mt-6">
            <button type="submit" v-on:click="updateOrCreateSplashPage" class="rounded-sm px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white"  v-if="$store.getters.can(pageId == null ? 'create_splash_pages' :'edit_splash_pages')">
                {{pageId == null ? "Create":"Update"}}
            </button>
        </div>
    </div>
</template>

<script>
    import Utils from "../services/Utils";
    import SplashPageService from "../services/splashPage.service";

    export default {
        name: "UpdateOrCreateSplashPageComponent",
        props: {
            pageId: String
        },
        data() {
            return {
                name: null,
                css_template: null,
                splashPage: null,
                description: null,
                loading: false,
                errors: []
            }
        },
        mounted() {
            if (this.pageId != null)
                this.getSplashPage()
        },
        watch: {
            splashPage: function (splashPage) {
                this.name = splashPage.name;
                this.css_template = splashPage.css_template;
                this.description = splashPage.description;
            },
            errors: function (errors) {
                this.$root.$emit('alert_error', errors);
            }
        },
        methods: {
            getSplashPage() {
                SplashPageService.getOne(this.pageId).then(response => {
                    this.splashPage = response.page;
                })
            },

            updateOrCreateSplashPage() {
                this.loading = true;
                this.errors = [];
                if (this.name == null || this.name === '')
                    this.errors.push("Name field is required.");
                if (this.errors.length > 0) {
                    this.loading = false;
                    return;
                }

                let params = {
                    name: this.name,
                    css_template: this.css_template,
                    description: this.description,
                    organization_id: this.$store.getters.orgId
                };

                let request = this.pageId == null ? SplashPageService.create(params) : SplashPageService.update(this.pageId, params)

                request.then((result) => {
                    if (result.page != null) {
                        this.$root.$emit('alert_success', [result.message]);
                        this.$root.$emit(this.pageId == null ? "page_created" : "refresh_page", true)
                        this.splashPage = result.page;
                    } else {
                        if (result.error != null && result.error.response != null && result.error.response.status === 422)
                            this.errors = Utils.processError(result.error.response.data);
                        else
                            this.errors.push(result.message)
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>